module.exports = {
  CACHE_KEYS: {
    API_CALLS: 'api-calls',
    CDNS: 'cdns',
    IMAGES_UPLOADED: 'images-uploaded',
  },
}
